



































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {CommonConstant} from "@/common-constant";
import {UserInfoInputModel} from "@/model/user-info/user-info-input.model";
import {UserInfoChecker} from "@/model/user-info/functions/user-info-input-checker";
import {AddressUtils} from "@/address-utils";

@Component
export default class UserInfoInput extends Vue {
    @Prop() private model: UserInfoInputModel;

    /** 性別のリスト */
    genderList: Array<any> = CommonConstant.GENDER_LIST;

    /** 名前の単項目チェック */
    inputName(): boolean {
        this.model.initName = false;
        return UserInfoChecker.checkName(this.model);
    }

    /** お名前(カタカナ) の単項目チェック */
    inputKana(): boolean {
        this.model.initKana = false;
        return UserInfoChecker.checkKana(this.model);
    }

    /** 性別をチェックする */
    selectGender(): boolean {
        this.model.initGender = false;
        return UserInfoChecker.checkGender(this.model);
    }

    /** 生年月日の整合性をチェックする */
    inputBirthday(): boolean {
        this.model.initBirthday = false;
        return UserInfoChecker.checkBirthday(this.model);
    }

    /** 電話番号の単項目チェック */
    inputTel(): boolean {
        return UserInfoChecker.checkTel(this.model);
    }

    /** 郵便番号をチェックする */
    inputPostalCode(): boolean {
        UserInfoChecker.checkPrefecture(this.model);
        return UserInfoChecker.checkPostalCode(this.model);
    }

    /** 郵便番号が変更された際の動作 */
    changePostalCode(){
        this.model.prefecture = "";
        this.model.city = "";
        this.model.streetAddress = "";
        UserInfoChecker.checkPrefecture(this.model);
    }

    /** 住所を検索する */
    searchAddress() {
        AddressUtils.searchAddress(this.model, this).then(() => {
            this.model.initPrefecture = false;
            UserInfoChecker.checkPrefecture(this.model);
        })
    }
}
